module.exports = __webpack_public_path__ + "img/Logo_ID.695165d9.png";